
import React , { useState  , useEffect , useContext } from "react";
import Chart from "react-apexcharts";
import  { WebAssetsContext }  from "../../App";
import 
{ 
  changeDateFotmate
} from '../../functions/Function';


const  Linechart = (props) => {
    const WebAssets = useContext(WebAssetsContext);
    const api = WebAssets.apiURL;
    const [pchart, setPchart] = useState(null);
    const getpchat = (dates , prices , productname) => 
    {
      let data = {
            
        series: [{
            name: productname,
            data: prices
        }],
        options: {
          chart: {
            height: 350,
            stacked: false,
            type: 'area',
            zoom: {
              type: 'x',
              enabled: true,
              autoScaleYaxis: true
            },
            toolbar: {
              autoSelected: 'zoom'
            }
          },
          dataLabels: {
            enabled: true
          },
          markers: {
            size: 0,
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text: productname+' PRICE HISTORY',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          xaxis: {
            categories: dates,
          }
        },
      
      
      };
  
        setPchart(data)
    } 
  const getProductPricehistory = async () => {
    try {
      const resJson = getProductPriceHistory();
      resJson.then(function(output) {
        if(output.status === true)
        {
         let storedates = [];
         let storeprice = [];
        
         if(output.response.prices && output.response.product)
          {
              output.response.prices.forEach((value, key, map)=>{
              storedates.push(changeDateFotmate(value.created_date , 'DD-MM-YYYY'));
              storeprice.push(value.price);
            });
            getpchat(storedates , storeprice , output.response.product.name);
          }
          
        }
    });
    } catch (err) {
      console.log(err);
    }
  };

  const getProductPriceHistory = async () => 
  {
    const res =  await fetch(api+"getProductPriceHistory", {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({id:props.id}),
          });
          let resJson = await res.json();
          return resJson;
  }

  useEffect(() => {
        getProductPricehistory();
   } , [props.id])

  return (
    <>
        {pchart != null ?
            <Chart options={pchart.options} series={pchart.series} type="area" height={props.height}   />
         : ''   }
    </>

  );
}

export default Linechart;
